/** 主色调：存 #hex（与 chatBg 同模式） */
export const themeStorageKey = 'im-primary-color';
export const themeDefaultColor = '#2830d3';

export const themeAccents = [
	{ id: 'default', nameKey: 'userConfig.themeAccentDefault', color: '#2830d3' },
	{ id: 'violet', nameKey: 'userConfig.themeAccentViolet', color: '#6d28d9' },
	{ id: 'teal', nameKey: 'userConfig.themeAccentTeal', color: '#0f766e' },
	{ id: 'green', nameKey: 'userConfig.themeAccentGreen', color: '#15803d' },
	{ id: 'amber', nameKey: 'userConfig.themeAccentAmber', color: '#c2410c' },
	{ id: 'rose', nameKey: 'userConfig.themeAccentRose', color: '#be123c' }
];

function isHex(value) {
	return typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value);
}

function clampByte(n) {
	return Math.max(0, Math.min(255, Math.round(n)));
}

function hexToRgb(hex) {
	return {
		r: parseInt(hex.slice(1, 3), 16),
		g: parseInt(hex.slice(3, 5), 16),
		b: parseInt(hex.slice(5, 7), 16)
	};
}

function rgbToHex({ r, g, b }) {
	const to = (n) => clampByte(n).toString(16).padStart(2, '0');
	return `#${to(r)}${to(g)}${to(b)}`;
}

/** 等同 Sass mix(#fff, primary, weight%)：weight 为白色占比 */
function mixWhite(primary, weight) {
	const w = weight / 100;
	const a = hexToRgb(primary);
	return rgbToHex({
		r: a.r * (1 - w) + 255 * w,
		g: a.g * (1 - w) + 255 * w,
		b: a.b * (1 - w) + 255 * w
	});
}

function mixBlack(primary, weight) {
	const w = weight / 100;
	const a = hexToRgb(primary);
	return rgbToHex({
		r: a.r * (1 - w),
		g: a.g * (1 - w),
		b: a.b * (1 - w)
	});
}

export function getThemeAccent() {
	const color = localStorage.getItem(themeStorageKey);
	return isHex(color) ? color.toLowerCase() : themeDefaultColor;
}

export function setThemeAccent(color) {
	const next = isHex(color) ? color.toLowerCase() : themeDefaultColor;
	localStorage.setItem(themeStorageKey, next);
	applyThemeAccent(next);
	return next;
}

export function applyThemeAccent(color) {
	const primary = isHex(color) ? color.toLowerCase() : themeDefaultColor;
	const root = document.documentElement;
	const { r, g, b } = hexToRgb(primary);
	root.style.setProperty('--im-color-primary', primary);
	root.style.setProperty('--im-color-primary-rgb', `${r}, ${g}, ${b}`);
	for (let i = 1; i <= 9; i++) {
		root.style.setProperty(`--im-color-primary-light-${i}`, mixWhite(primary, i * 10));
	}
	for (let i = 1; i <= 4; i++) {
		root.style.setProperty(`--im-color-primary-dark-${i}`, mixBlack(primary, i * 10));
	}
	root.style.setProperty('--im-background-active', mixWhite(primary, 95));
	root.style.setProperty('--im-background-active-dark', mixWhite(primary, 90));
	return primary;
}
